import { render, staticRenderFns } from "./poderi-aldo-conterno.vue?vue&type=template&id=93eca6f6&scoped=true"
import script from "./poderi-aldo-conterno.vue?vue&type=script&lang=js"
export * from "./poderi-aldo-conterno.vue?vue&type=script&lang=js"
import style0 from "./poderi-aldo-conterno.vue?vue&type=style&index=0&id=93eca6f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93eca6f6",
  null
  
)

export default component.exports